import { createElement } from 'react';
import { NumberPicker } from '@alifd/next';
import './index.scss';
const OadpAttributeNumber = function OadpAttributeNumber({ defaultValue, step, precision, max, min, label, size, type, editable, hasTrigger, alwaysShowTrigger, disabled, ...otherProps }) {
    return (createElement(NumberPicker, Object.assign({ defaultValue: defaultValue, step: step, precision: precision, max: max, min: min, label: label, size: size, type: type, editable: editable, hasTrigger: hasTrigger, alwaysShowTrigger: alwaysShowTrigger, disabled: disabled }, otherProps)));
};
export default OadpAttributeNumber;
